export default {
  get(context) {
    return new Promise((resolve, reject) => {
      window.axios
        .get(`/banners/home/`)
        .then(response => {
          context.commit("setBanners", response.data.banners);
          resolve(response.data.banners);
        })
        .catch(reject);
    });
  }
};
